import ChartDataLabels from "chartjs-plugin-datalabels";
import { BarElement, CategoryScale, LinearScale, Tooltip, Legend, Chart as ChartJS } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function GraficoDevs({ data, onBarClick }) {
  if (!data) return null;

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: "Abertos",
        data: data.abertos,
        backgroundColor: "rgba(83,74,183,0.75)",
        borderRadius: 6,
        borderSkipped: false,
      },
      {
        label: "Fechados",
        data: data.fechados,
        backgroundColor: "rgba(29,158,117,0.85)",
        borderRadius: 6,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 28, bottom: 4 } },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#64748b",
          font: { size: 11, family: "Inter" },
          boxWidth: 12,
          padding: 16,
        },
      },
      tooltip: {
        backgroundColor: "rgba(11,22,42,0.95)",
        borderColor: "rgba(96,165,250,0.2)",
        borderWidth: 1,
        titleColor: "#94a3b8",
        bodyColor: "#e2e8f0",
        padding: 10,
        cornerRadius: 8,
      },
      datalabels: {
        anchor: "end",
        align: "top",
        font: { size: 12, weight: "700", family: "Inter" },
        formatter: (value) => (value > 0 ? value : ""),
        color: (ctx) => (ctx.datasetIndex === 0 ? "#AFA9EC" : "#7BD4BB"),
        padding: { bottom: 2 },
      },
    },
    onClick: (event, elements) => {
      if (!elements.length || !onBarClick) return;
      const { datasetIndex, index } = elements[0];
      const nome = data.labels[index];
      const tipo = datasetIndex === 0 ? "abertos" : "fechados";
      onBarClick(nome, tipo);
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#94a3b8", font: { size: 11 } },
        border: { display: false },
      },
      y: {
        grid: { color: "rgba(96,165,250,0.06)" },
        ticks: { color: "#64748b", font: { size: 10 }, stepSize: 1 },
        border: { display: false },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%", cursor: onBarClick ? "pointer" : "default" }}>
      <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
}
